import { baseApi } from "@/core/api/baseApi";
import type {
  CaregiverQuestionnaireDTO,
  CaregiverQuestionnaireResponseDTO,
} from "../../domain/dto/ClinicalExaminationDTO";
import type {
  NeurologicalHistoryFormData,
  BehavioralFormData,
  CognitiveFunctionalFormData,
} from "../../presentation/pages/ClinicalExamination/types";
import {
  initialNeurologicalFormData,
  initialBehavioralFormData,
  initialCognitiveFunctionalFormData,
} from "../../presentation/pages/ClinicalExamination/types";
import {
  mapCaregiverQuestionnaireRequestBody,
  type CaregiverQuestionnaireSkippedSteps,
} from "./mappers/clinicalExaminationMapper";

export const caregiverQuestionnaireApi = baseApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    submitCaregiverQuestionnaire: builder.mutation<
      CaregiverQuestionnaireDTO,
      {
        assessmentId: string;
        neurological?: NeurologicalHistoryFormData;
        behavioral?: BehavioralFormData;
        cognitiveFunctional?: CognitiveFunctionalFormData;
        skippedSteps?: CaregiverQuestionnaireSkippedSteps;
      }
    >({
      query: ({
        assessmentId,
        neurological,
        behavioral,
        cognitiveFunctional,
        skippedSteps,
      }) => ({
        url: `/assessments/${assessmentId}/caregiver-questionnaire`,
        method: "POST",
        body: mapCaregiverQuestionnaireRequestBody(
          neurological ?? initialNeurologicalFormData,
          behavioral ?? initialBehavioralFormData,
          cognitiveFunctional ?? initialCognitiveFunctionalFormData,
          skippedSteps,
        ),
      }),
      transformResponse: (
        response: CaregiverQuestionnaireResponseDTO,
      ): CaregiverQuestionnaireDTO => response.data,
      invalidatesTags: (result, error, { assessmentId }) => [
        { type: "Assessments" as const, id: assessmentId },
        { type: "Assessments" as const, id: "LIST" },
      ],
    }),
  }),
});

export const { useSubmitCaregiverQuestionnaireMutation } =
  caregiverQuestionnaireApi;
